import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row g-0" }
const _hoisted_2 = { class: "price-search-card first-card" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = {
  key: 0,
  class: "mb-0 usage"
}
const _hoisted_5 = {
  key: 1,
  class: "mb-0 usage-ht"
}
const _hoisted_6 = { class: "col-12 col-xxl-9" }
const _hoisted_7 = { class: "price-search-card__bottom" }
const _hoisted_8 = { class: "price-search-card__search" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "search__content title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "price-search-card__title" }, " Suche verfeinern ")
], -1)
const _hoisted_10 = {
  key: 0,
  class: "search__content"
}
const _hoisted_11 = {
  key: 1,
  class: "search__content"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1)

import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import SelectField from '@/components/SelectField.vue';
import Expand from '@/components/Expand.vue';
import Expansion from '@/components/Expansion.vue';
import { formatNumber } from '@/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceSearchCard',
  props: {
  options: {
    type: Object,
    required: true,
  },
},
  setup(__props) {



const store = useStore();

const filterOptions = computed(() => store.getters['priceshow/filterOptions']);
const hasFilterOptions = computed(() => store.getters['priceshow/hasFilterOptions']);
const calculatorOpen = ref(false);

const filter = computed({
  get() {
    return store.getters['priceshow/filter'];
  },
  set(value) {
    store.commit('priceshow/SET_FILTER', value);
  },
});

return (_ctx: any,_cache: any) => {
  const _component_BaseCalculator = _resolveComponent("BaseCalculator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["price-search-card__overlay", { 'show': calculatorOpen.value }])
    }, null, 2),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["col-12 col-xxl-3", { 'show': calculatorOpen.value }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["price-search-card__top", { 'open': calculatorOpen.value }])
          }, [
            _createElementVNode("p", _hoisted_3, " Deine Postleitzahl: " + _toDisplayString(__props.options.postcode), 1),
            (__props.options.double === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Dein Verbrauch / Jahr: " + _toDisplayString(_unref(formatNumber)(__props.options.usage, 0)) + " kWh ", 1))
              : (__props.options.double === 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Dein HT/NT Verbrauch: " + _toDisplayString(_unref(formatNumber)(__props.options.usageHt, 0)) + " /" + _toDisplayString(_unref(formatNumber)(__props.options.usage, 0)) + " kWh ", 1))
                : _createCommentVNode("", true),
            _createVNode(Expand, {
              type: "small",
              onToggle: _cache[0] || (_cache[0] = ($event: any) => (calculatorOpen.value = $event))
            }, {
              title: _withCtx(() => [
                _createTextVNode("Angaben ändern")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_BaseCalculator, {
                  postcode: __props.options.postcode,
                  "preselected-options": __props.options,
                  type: "component"
                }, null, 8, ["postcode", "preselected-options"])
              ]),
              _: 1
            })
          ], 2)
        ])
      ], 2),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(["price-search-card second-card", { 'show': calculatorOpen.value }])
        }, [
          (hasFilterOptions.value)
            ? (_openBlock(), _createBlock(Expansion, {
                key: 0,
                expanded: true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      (filterOptions.value.priceGuarantee.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createVNode(SelectField, {
                              label: "Preisgarantie",
                              modelValue: filter.value.priceGuarantee,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filter.value.priceGuarantee) = $event)),
                              options: filterOptions.value.priceGuarantee
                            }, null, 8, ["modelValue", "options"])
                          ]))
                        : _createCommentVNode("", true),
                      (filterOptions.value.contractTerm.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(SelectField, {
                              label: "Laufzeit",
                              modelValue: filter.value.contractTerm,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filter.value.contractTerm) = $event)),
                              options: filterOptions.value.contractTerm
                            }, null, 8, ["modelValue", "options"])
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_12
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ])
  ], 64))
}
}

})